export default () => {
  const hostConfig = {
    test: ["test.us.9five.cn", "test.seller.9five.ai"],
    uat: ["test.us.9five.cn", "test.seller.9five.ai"],
    prod: ["seller-us.9five.ai"],
  };
  const host = document.domain.toLowerCase();
  let env = "dev";

  Object.keys(hostConfig).some((key) => {
    if (hostConfig[key].includes(host)) {
      env = key;
      return true;
    }
    return false;
  });

  return env;
};
